import React from 'react';

class EntryList extends React.Component {
  render() {
    const entries = this.props.entries.map((entry) =>
      <li>{entry.title}</li>
    );

    return (
    <ul>
      {entries}
    </ul>
    );
  }
}

export default EntryList;


// WEBPACK FOOTER //
// ./src/components/EntryList.js